 /* lua.js generated code 0.3.0 */
require("clover/data/ItemDataManager")
var Event = require("cocos/framework/components/event")
let AIPkgManager = require("activity/AIPackage/AIPkgManager");
require("activity/TrinityGiftBag/TrinityGiftBagManager")
UserDeal = xClass("UserDeal", Event)
UserDealPayType = table(
    [1, "kUnsupport", 0],
    [1, "kCoin", 1],
    [1, "kCash", 2],
    [1, "kIngame", 3],
    [1, "kAlipay", 4],
    [1, "kWechat", 5],
    [1, "kQQ", 6],
    [1, "kHuawei", 7],
    [1, "kAlipayMi", 8],
    [1, "kWechatMi", 9],
    [1, "kAlipayQihoo", 10],
    [1, "kWechatQihoo", 11],
    [1, "kWo3Pay", 12],
    [1, "kVIVO", 13],
    [1, "kVIVO_WX", 14],
    [1, "kVIVO_ALI", 15]
)
var instance = null
UserDeal.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserDeal.new()
    }
    return instance
}
UserDeal.prototype.ctor = function () {
    var self = this
    self.bind(self)
    self.defaultPayType = UserDealPayType.kUnsupport
    self.userDealTypeRef = require("clover/logic/userDeal/UserDealPayTypeEnum")
    self.userDealValidate = require("clover/logic/userDeal/UserDealValidate")
}
//@param payType UserDealPayType
UserDeal.prototype.getPayment = function (payType) {
    var self = this
    return self.userDealTypeRef[payType]
}
UserDeal.prototype.getAvaliableCoin = function () {
    var self = this
    var coin = UserManager.getInstance().getUserRef().getCoin()
    // WARN: maybe multi result
    return Math.max(coin - self.lockedCoin, 0)
}
UserDeal.prototype.getAvaliableCash = function () {
    var self = this
    var coin = UserManager.getInstance().getUserRef().getCash()
    // WARN: maybe multi result
    return Math.max(coin - self.lockedCash, 0)
}
UserDeal.prototype.canBuyGoods = function (goodsId, num, forcePayType) {
    var self = this
    var [success, errCode] = self.userDealValidate(goodsId, num)
    if (!success) {
        he_log_info("not validate goods:" + goodsId)
        return [success, errCode]
    }
    var payType
    if (forcePayType) {
        payType = forcePayType
    } else {
        payType = UserDealData.getGoodsPayType(goodsId)
    }
    if (!payType || payType === UserDealPayType.kUnsupport) {
        he_log_info("not support paytype. " + table.tostring(payType) + ", " + table.tostring(forcePayType))
        return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
    }
    return (self.userDealTypeRef[payType]).prototype.canBuyGoods.call(self, goodsId, num) // 删除2个没定义的, targetId, param)
}
UserDeal.prototype.buyGoods = function (goodsId, num, forcePayType, targetId, param, successCallback, failCallback, cancelCallback, sceneName4GetCurrency) {
    var self = this
    // body
    self.afterCheckBuyGoods(goodsId, num, forcePayType, targetId, param, successCallback, failCallback, cancelCallback, sceneName4GetCurrency)
}
// focePayType指定了支付方式，如果支付方式不被支持则会报错，如果不写则会由系统自己判断一个首选方式。
UserDeal.prototype.afterCheckBuyGoods = function (goodsId, num, forcePayType, targetId, param, successCallback, failCallback, cancelCallback, sceneName4GetCurrency) {
    var self = this
    var payType
    if (forcePayType) {
        payType = forcePayType
    } else {
        payType = UserDealData.getGoodsPayType(goodsId)
    }
    targetId = targetId || goodsId
    var sceneName = ""
    var coin1 = 0
    if (payType === UserDealPayType.kCoin) {
        sceneName = ModuleName.BUY_GAME_COINS
        coin1 = UserManager.getInstance().getUserRef().getCoin() || 0
    } else if (payType === UserDealPayType.kCash) {
        sceneName = ModuleName.BUY_HAPPY_COINS
        coin1 = UserManager.getInstance().getUserRef().getCash() || 0
    } else if (payType === UserDealPayType.kUnsupport) {
        sceneName = ""
        coin1 = 0
    } else {
        sceneName = ModuleName.BUY_RMB_COINS
        coin1 = 0
    }
    function onSuccess(event) {
        if (payType !== UserDealPayType.kCoin && payType !== UserDealPayType.kCash && payType !== UserDealPayType.kUnsupport) {
            require("clover/data/PaymentRecordManager")
            PaymentRecordManager.getInstance().setLogDirty()
            self.setLastSuccessPayType(payType)
        }

        let tradeId = "0";
        if (payType == UserDealPayType.kCoin || payType == UserDealPayType.kCash) {
            tradeId = `${UserManager.getInstance().uid}_${goodsId}_${Localhost.timeInSec()}`
        }
        let itemWorth = ItemWorth.OTHER;
        if (payType == UserDealPayType.kCoin) {
            itemWorth = ItemWorth.GAME_COINS;
        } else if (payType == UserDealPayType.kCash) {
            itemWorth = ItemWorth.HAPPY_COINS;
        }
        if (param && param.source) {
            self.deliverGoods(goodsId, num, sceneName, {"trade_id": tradeId, "source": param.source, item_worth: itemWorth})
        } else {
            self.deliverGoods(goodsId, num, sceneName, {"trade_id": tradeId, item_worth: itemWorth})
        }
        if (payType === UserDealPayType.kCoin || payType === UserDealPayType.kCash) {
            var coin2 = 0
            var currency = ""
            var currency_num = 0
            var cost = 0
            var revenueCost = 0
            var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId) || GoodsMetaRef.create()
            if (payType === UserDealPayType.kCoin) {
                coin2 = UserManager.getInstance().getUserRef().getCoin() || 0
                currency = ItemWorth.GAME_COINS
                currency_num = (goodsMeta.getCoin() || 0) * num
                cost = goodsMeta.coin || 0
                revenueCost = goodsMeta.coin || cost //如果折扣价格配置为0 则记录原价
            } else {
                coin2 = UserManager.getInstance().getUserRef().getCash() || 0
                currency = ItemWorth.HAPPY_COINS
                currency_num = (goodsMeta.getCash() || 0) * num
                cost = goodsMeta.qCash || 0
                revenueCost = goodsMeta.discountQCash || cost //如果折扣价格配置为0 则记录原价
            }
            var dcData = table()
            dcData.currency = currency
            dcData.currency_num = currency_num
            dcData.coin1 = coin1
            dcData.coin2 = coin2
            dcData.cost = cost
            dcData.revenueCost = revenueCost
            dcData.trade_id = tradeId;
            DCAssist.dc4UseCurrency(goodsId, num, sceneName4GetCurrency || "", dcData)
        } else if (payType === UserDealPayType.kUnsupport) { } else if (__ANDROID) {
            //新增人民币购买打点
            var coin2 = 0
            var currency = ""
            var currency_num = 0
            var cost = 0
            var revenueCost = 0
            var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId) || GoodsMetaRef.create()
            coin2 = 0
            currency = ItemWorth.RMB
            if (payType === UserDealPayType.kIngame) {
                currency_num = (goodsMeta.getRmb() || 0) * num
            } else {
                currency_num = (goodsMeta.getThirdRmb() || 0) * num
            }
            cost = goodsMeta.rmb || 0
            revenueCost = goodsMeta.discountRmb || cost //如果折扣价格配置为0 则记录原价
            var dcData = table()
            dcData.currency = currency
            dcData.currency_num = currency_num
            dcData.coin1 = coin1
            dcData.coin2 = coin2
            dcData.cost = cost
            dcData.revenueCost = revenueCost
            dcData.trade_id = tradeId;
            DCAssist.dc4UseCurrency(goodsId, num, sceneName4GetCurrency || "", dcData)
        }
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(goodsId, num, payType, 0, 0)
            CacheManager.getInstance().cleanPaymentTradeID()
        }
        UserManager.getInstance().flushUserData()
        if (successCallback) {
            successCallback(event)
        }
    }
    function onError(event) {
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(goodsId, num, payType, 5, event && tostring(event.data) || "")
            CacheManager.getInstance().cleanPaymentTradeID()
        }
        if (type(failCallback) === "function") {
            failCallback(event)
        }
    }
    function onCancel(event) {
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(goodsId, num, payType, 6, 0)
            CacheManager.getInstance().cleanPaymentTradeID()
        }
        if (type(cancelCallback) === "function") {
            cancelCallback(event)
        }
    }
    cc.log("UserDeal:buyGoods:", payType, forcePayType)
    var [success, errCode] = self.canBuyGoods(goodsId, num, forcePayType)
    if (!success) {
        cc.log(">>>>UserDeal:buyGoods canBuyGoods false")
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(goodsId, num, payType, self.getErrorCodeClientMapValue(errCode), self.getErrorCodeClient(errCode))
        }
        if (failCallback) {
            failCallback(table([1, "data", errCode]))
        }
        return 
    }
    function checkSuccess() {
        // body
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            CacheManager.getInstance().initPaymentTradeID()
           // DCAssist.dc4AndroidPayStart(goodsId, num, payType)
        }
        (self.userDealTypeRef[payType]).prototype.buyGoods(goodsId, num, targetId, param, onSuccess, onError, onCancel)
    }
    function checkFail(evt) {
        // body
        if (failCallback) {
            failCallback(table([1, "data", ZooErrorCode.VERIFIED_FAILED]))
        }
    }
    if (payType === UserDealPayType.kUnsupport || payType === UserDealPayType.kCoin) {
        checkSuccess()
    } else {
        checkSuccess()
        // FIXME: VerifiedManager
        // VerifiedManager.getInstance().check(checkSuccess, checkFail, ModuleName.SHOP)
    }
}
var CLOVER_LAST_SUCCESS_PAYTYPE = "clover_last_success_paytype"
var CLOVER_DEFAULT_PAYTYPE = "clover_default_paytype"
UserDeal.prototype.setLastSuccessPayType = function (payType) {
    var self = this
    if (PlatformConfig.isPlatform(PlatformNameEnum.kHE) && MaintenanceManager.getInstance().isEnabled("SkipLastPayPriority")) {
        he_log_info("he platform skip save last pay priority")
    } else {
        if (payType === UserDealPayType.kIngame || payType === UserDealPayType.kWo3Pay) {
            if (self.getLastSuccessPayType() === payType) {
                Cookie.getInstance().write(CLOVER_DEFAULT_PAYTYPE, payType)
            }
        } else {
            Cookie.getInstance().write(CLOVER_DEFAULT_PAYTYPE, payType)
        }
        Cookie.getInstance().write(CLOVER_LAST_SUCCESS_PAYTYPE, payType)
    }
}
//@ return UserDealPayType
UserDeal.prototype.getLastSuccessPayType = function () {
    var self = this
    return Cookie.getInstance().read(CLOVER_LAST_SUCCESS_PAYTYPE) || UserDealPayType.kUnsupport
}
UserDeal.prototype.getDefaultPayType = function () {
    var self = this
    return Cookie.getInstance().read(CLOVER_DEFAULT_PAYTYPE) || UserDealPayType.kUnsupport
}
// 其他模块在成功支付过后会直接调用这个接口加道具（目前关前道具购买用了Item表，因此关前道具相关逻辑不再使用这个函数了）
UserDeal.prototype.deliverGoods = function (goodsId, num, sceneName, dcData, extreItems, onlyDC) {
    var self = this
    extreItems = extreItems || table()
    UserManager.getInstance().addBuyedGoods(goodsId, num)
    var goodsMeta = null, itemsList = null;
    if (AIPkgManager.IsAiPackage(goodsId)) {
        // 如果是AI礼包，这里模拟下文需要用到的goodsMeta方法，以及拼装相应的itemList
        itemsList = table();
        let pkg = AIPkgManager.getInstance().getPackageMeta(goodsId);
        if (pkg) {
            for(let key in pkg.items) {                
                table.insert(itemsList, { itemId: key * 1, num: pkg.items[key] });
            }
            if ($len(extreItems) > 0) {
                for (let index = 1; index <= $len(extreItems); index++) {
                    let v = extreItems[index]
                    if (!v) {
                        continue
                    }
                    table.insert(itemsList, extreItems[index])
                }
            }
        }
        goodsMeta = {
            getCoin() { return 0; },
            getCash() { return 0; },
            getThirdRmb() { return pkg ? pkg.rmb / 10 : 1}, // 单位为角
        }
    } else if(TrinityGiftBagManager.getInstance().isTrinityGiftBag(goodsId)) {
        itemsList = table();
        let cfg = TrinityGiftBagManager.getInstance().getRewardById(goodsId);
        if (cfg && cfg.itemRewards) {
            let list = cfg.itemRewards.split(",");
            //
            for (let j = 0; j < list.length; j++) {
                const arr = list[j].split(":");
                const itemId = Number(arr[0]);
                const num = Number(arr[1]);
                table.insert(itemsList, { itemId, num })
            }
            if ($len(extreItems) > 0) {
                for (let index = 1; index <= $len(extreItems); index++) {
                    let v = extreItems[index]
                    if (!v) {
                        continue
                    }
                    table.insert(itemsList, extreItems[index])
                }
            }
        }
        goodsMeta = {
            getCoin() { return 0; },
            getCash() { return 0; },
            getThirdRmb() { return cfg ? cfg.price * 10 : 1}, // 单位为角
        }
    } else {
        goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId) || GoodsMetaRef.create()
        itemsList = goodsMeta.items || table()
        if ($len(extreItems) > 0) {
            for (let index = 1; index <= $len(extreItems); index++) {
                let v = extreItems[index]
                if (!v) {
                    continue
                }
                table.insert(itemsList, extreItems[index])
            }
        }
    }
    var priceAll = 0
    var priceTotal = 0
    var item_worth = ItemWorth.OTHER
    if (sceneName === ModuleName.BUY_GAME_COINS) {
        priceAll = goodsMeta.getCoin() || 0
        item_worth = ItemWorth.GAME_COINS
        sceneName = sceneName = ModuleName.SHOP
    } else if (sceneName === ModuleName.BUY_HAPPY_COINS) {
        priceAll = goodsMeta.getCash() || 0
        item_worth = ItemWorth.HAPPY_COINS
        sceneName = sceneName = ModuleName.SHOP
    } else if (sceneName === ModuleName.BUY_RMB_COINS) {
        priceAll = goodsMeta.getThirdRmb()
        if (priceAll === 0) {
            priceAll = goodsMeta.getRmb() || 0
        }
        item_worth = ItemWorth.RMB
        sceneName = sceneName = ModuleName.SHOP
    } else if(dcData && dcData.item_worth) {
        item_worth = dcData.item_worth
        if (dcData.item_worth == ItemWorth.GAME_COINS) {
            priceAll = goodsMeta.getCoin() || 0
        } else if (dcData.item_worth == ItemWorth.HAPPY_COINS) {            
            priceAll = goodsMeta.getCash() || 0
        } else if(dcData.item_worth == ItemWorth.RMB) {
            priceAll = goodsMeta.getThirdRmb()
            if (priceAll === 0) {
                priceAll = goodsMeta.getRmb() || 0
            }
        }
    }
    for (var i = 1, v = itemsList[1]; v; i++, v = itemsList[i]) {
        priceTotal = priceTotal + getItemPrice(v.itemId) * v.num * num
    }
    let targetId
    let param
    for (var i = 1, v = itemsList[1]; v; i++, v = itemsList[i]) {
        var coin1 = 0
        if (tonumber(v.itemId) === ItemType.COIN) {
            coin1 = UserManager.getInstance().getUserRef().getCoin() || 0
        } else if (tonumber(v.itemId) === ItemType.GOLD) {
            coin1 = UserManager.getInstance().getUserRef().getCash() || 0
        } else {
            coin1 = 0
        }
        // 记录获得道具前的数量
        let item1 
        if (onlyDC){
            item1 = getPropNumber(v.itemId) - v.num * num;
            // UserProp.getInstance().addProp(v.itemId, v.num * num, targetId || goodsId, param, sceneName)
        }else {
            item1 = getPropNumber(v.itemId);
            UserProp.getInstance().addProp(v.itemId, v.num * num, targetId || goodsId, param, sceneName)
        }
        dcData = dcData || table()
        dcData.item_worth = item_worth
        dcData.worth_num = 0
        dcData.goods_id = goodsId
        dcData.item1 = item1;
        dcData.item2 = getPropNumber(v.itemId);
        if (priceTotal && priceTotal > 0) {
            if (dcData.item_worth == ItemWorth.OTHER) { } else {
                // worth_num需求打单位：元
                let scale = dcData.item_worth == ItemWorth.RMB? 0.1: 1; // 人民币支付需要从角转换为元
                dcData.worth_num = string.format("%.4f", priceAll == 0? 0: ((getItemPrice(v.itemId) * v.num * num) / priceTotal * (priceAll * scale)));   // 避免太长，保留四位小数
            }
        }
        // DCAssist.dc4GetThings(v.itemId, v.num * num, sceneName, dcData)
        //  为区别道具购买来源，因此需要从外部通过dcData.source参数传入来源信息，如果不存在来源信息，则使用默认的Shop
        if (dcData.source) {
            DCAssist.dc4GetThings(v.itemId, v.num * num, dcData.source, dcData)
        } else {
            DCAssist.dc4GetThings(v.itemId, v.num * num, sceneName, dcData)
        }
        var coin2 = 0
        if (tonumber(v.itemId) === ItemType.COIN) {
            coin2 = UserManager.getInstance().getUserRef().getCoin() || 0
        } else if (tonumber(v.itemId) === ItemType.GOLD) {
            coin2 = UserManager.getInstance().getUserRef().getCash() || 0
        } else {
            coin2 = 0
        }
        dcData = dcData || table()
        dcData.coin1 = coin1 || 0
        dcData.coin2 = coin2 || 0
        dcData.goods_id = goodsId;
        //  为区别货币获得来源，因此需要从外部通过dcData.source参数传入来源信息，如果不存在来源信息，则使用默认的Shop
        if (dcData.source) {
            DCAssist.dc4GetCurrency(v.itemId, v.num * num, dcData.source, dcData)
        } else {
            DCAssist.dc4GetCurrency(v.itemId, v.num * num, sceneName, dcData)
        }
    }
}
UserDeal.prototype.getErrorCodeClient = function (errorCode) {
    var self = this
    var error_code = "client_"
    return error_code + tostring(errorCode)
}
UserDeal.prototype.getErrorCodeClientMapValue = function (errorCode) {
    var self = this
    if (errorCode === ZooErrorCode.BUY_GOOODSID_INVAILD) {
        return 10001
    } else if (errorCode === ZooErrorCode.BUY_LEVEL_NOT_ENOUGH) {
        return 10002
    } else if (errorCode === ZooErrorCode.BUY_LIMIT_GOODS_ERROR_OVER_LIMIT) {
        return 10003
    } else if (errorCode === ZooErrorCode.BUY_WRONG_MONEY_TYPE) {
        return 10004
    } else if (errorCode === ZooErrorCode.COIN_NOT_ENOUGH) {
        return 10005
    } else if (errorCode === ZooErrorCode.CASH_NOT_ENOUGH) {
        return 10006
    } else if (errorCode === ZooErrorCode.PAY_TYPE_UNSUPPORT) {
        return 10007
    } else if (errorCode === ZooErrorCode.PAY_EXCEED_DAILY_LIMIT) {
        return 10008
    } else if (errorCode === ZooErrorCode.PAY_EXCEED_MONTHLY_LIMIT) {
        return 10009
    }
    return 99999
}
/**
 * 购买Item道具
 */
UserDeal.prototype.buyItem = function (itemId, num, forcePayType, targetId, param, successCallback, failCallback, cancelCallback, sceneName4GetCurrency) {
    var self = this
    // body
    self.afterCheckBuyItem(itemId, num, forcePayType, targetId, param, successCallback, failCallback, cancelCallback, sceneName4GetCurrency)
}
UserDeal.prototype.afterCheckBuyItem = function (itemId, num, forcePayType, targetId, param, successCallback, failCallback, cancelCallback, sceneName4GetCurrency) {
    var self = this
    var payType = forcePayType
    targetId = targetId || itemId
    var sceneName = ""
    var coin1 = 0
    if (payType === UserDealPayType.kCoin) {
        sceneName = ModuleName.BUY_GAME_COINS
        coin1 = UserManager.getInstance().getUserRef().getCoin() || 0
    } else if (payType === UserDealPayType.kCash) {
        sceneName = ModuleName.BUY_HAPPY_COINS
        coin1 = UserManager.getInstance().getUserRef().getCash() || 0
    } else if (payType === UserDealPayType.kUnsupport) {
        sceneName = ""
        coin1 = 0
    } else {
        sceneName = ModuleName.BUY_RMB_COINS
        coin1 = 0
    }
    function onSuccess(event) {
        if (payType !== UserDealPayType.kCoin && payType !== UserDealPayType.kCash && payType !== UserDealPayType.kUnsupport) {
            require("clover/data/PaymentRecordManager")
            PaymentRecordManager.getInstance().setLogDirty()
            self.setLastSuccessPayType(payType)
        }

        let tradeId = "0";
        if (payType == UserDealPayType.kCoin || payType == UserDealPayType.kCash) {
            tradeId = `${UserManager.getInstance().uid}_${itemId}_${Localhost.timeInSec()}`
        }
        let itemWorth = ItemWorth.OTHER;
        if (payType == UserDealPayType.kCoin) {
            itemWorth = ItemWorth.GAME_COINS;
        } else if (payType == UserDealPayType.kCash) {
            itemWorth = ItemWorth.HAPPY_COINS;
        }
        if (param && param.source) {
            self.deliverItem(itemId, num, sceneName, {"trade_id": tradeId, "source": param.source, item_worth: itemWorth})
        } else {
            self.deliverItem(itemId, num, sceneName, {"trade_id": tradeId, item_worth: itemWorth})
        }
        if (payType === UserDealPayType.kCoin || payType === UserDealPayType.kCash) {
            var coin2 = 0
            var currency = ""
            var currency_num = 0
            var cost = 0
            var revenueCost = 0
            var itemData = ItemDataManager.getItemDataById(itemId)
            if (payType === UserDealPayType.kCoin) {
                coin2 = UserManager.getInstance().getUserRef().getCoin() || 0
                currency = ItemWorth.GAME_COINS
            } else {
                coin2 = UserManager.getInstance().getUserRef().getCash() || 0
                currency = ItemWorth.HAPPY_COINS
            }
            currency_num = (itemData.price || 0) * num
            if (itemData.discount > 0) {
                cost = Math.round(itemData.price / itemData.discount) || 0
            } else {
                cost = 0
            }
            revenueCost = itemData.price || 0

            var dcData = table()
            dcData.currency = currency
            dcData.currency_num = currency_num
            dcData.coin1 = coin1
            dcData.coin2 = coin2
            dcData.cost = cost
            dcData.revenueCost = revenueCost
            dcData.trade_id = tradeId;
            DCAssist.dc4UseCurrency(itemData.id + "_item", num, sceneName4GetCurrency || "", dcData)
        } else if (payType === UserDealPayType.kUnsupport) { } else if (__ANDROID) {
            //新增人民币购买打点
            var coin2 = 0
            var currency = ""
            var currency_num = 0
            var cost = 0
            var revenueCost = 0
            var itemData = ItemDataManager.getItemDataById(itemId)
            coin2 = 0
            currency = ItemWorth.RMB
            if (payType === UserDealPayType.kIngame) {
                currency_num = (itemData.price || 0) * num
            } else {
                currency_num = (itemData.price || 0) * num
            }
            cost = Math.round(itemData.price / itemData.discount) || 0
            revenueCost = itemData.price || 0
            var dcData = table()
            dcData.currency = currency
            dcData.currency_num = currency_num
            dcData.coin1 = coin1
            dcData.coin2 = coin2
            dcData.cost = cost
            dcData.revenueCost = revenueCost
            dcData.trade_id = tradeId;
            DCAssist.dc4UseCurrency(itemData.propId, num, sceneName4GetCurrency || "", dcData)
        }
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(goodsId, num, payType, 0, 0)
            CacheManager.getInstance().cleanPaymentTradeID()
        }
        UserManager.getInstance().flushUserData()
        if (successCallback) {
            successCallback(event)
        }
    }
    function onError(event) {
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(itemId, num, payType, 5, event && tostring(event.data) || "")
            CacheManager.getInstance().cleanPaymentTradeID()
        }
        if (type(failCallback) === "function") {
            failCallback(event)
        }
    }
    function onCancel(event) {
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(itemId, num, payType, 6, 0)
            CacheManager.getInstance().cleanPaymentTradeID()
        }
        if (type(cancelCallback) === "function") {
            cancelCallback(event)
        }
    }
    var [success, errCode] = self.canBuyItem(itemId, num, forcePayType)
    if (!success) {
        cc.log(">>>>UserDeal:buyItem canBuyItem false")
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            // DCAssist.dc4AndroidPayEnd(itemId, num, payType, self.getErrorCodeClientMapValue(errCode), self.getErrorCodeClient(errCode))
        }
        if (failCallback) {
            failCallback(table([1, "data", errCode]))
        }
        return 
    }
    function checkSuccess() {
        // body
        if (sceneName === ModuleName.BUY_RMB_COINS) {
            //  玩家充钱
            CacheManager.getInstance().initPaymentTradeID()
          //  DCAssist.dc4AndroidPayStart(itemId, num, payType)
        }
        (self.userDealTypeRef[payType]).prototype.buyItem(itemId, num, onSuccess, onError, onCancel)
    }
    function checkFail(evt) {
        // body
        if (failCallback) {
            failCallback(table([1, "data", ZooErrorCode.VERIFIED_FAILED]))
        }
    }
    if (payType === UserDealPayType.kUnsupport || payType === UserDealPayType.kCoin || payType === UserDealPayType.kCash) {
        checkSuccess()
    } else {
        checkSuccess()
        // FIXME: VerifiedManager
        // VerifiedManager.getInstance().check(checkSuccess, checkFail, ModuleName.SHOP)
    }
}
/**
 * 检查是否可以购买道具
 */
UserDeal.prototype.canBuyItem = function (itemId, num, forcePayType) {
    var self = this
    if (forcePayType === UserDealPayType.kUnsupport) {
        he_log_info("not support paytype. " + table.tostring(forcePayType) + ", " + table.tostring(forcePayType))
        return [false, ZooErrorCode.BUY_WRONG_MONEY_TYPE]
    }
    return (self.userDealTypeRef[forcePayType]).prototype.canBuyItem.call(self, itemId, num) // 删除2个没定义的, targetId, param)
}

// 其他模块在成功支付过后会直接调用这个接口加道具
UserDeal.prototype.deliverItem = function (itemId, num, sceneName, dcData, extreItems) {
    var self = this
    extreItems = extreItems || table()
    //  Item暂时没有每日限购    UserManager.getInstance().getDailyData().addBuyedGoods(itemId, num)
    // var goodsMeta = MetaManager.getInstance().getGoodsMeta(itemId) || GoodsMetaRef.create()
    var itemData = ItemDataManager.getItemDataById(itemId)
    var itemsList = table()
    table.insert(itemsList, itemData)
    // if ($len(extreItems) > 0) {
    //     for (let index = 1; index <= $len(extreItems); index++) {
    //         let v = extreItems[index]
    //         if (!v) {
    //             continue
    //         }
    //         table.insert(itemsList, extreItems[index])
    //     }
    // }
    // var priceAll = 0
    var priceTotal = itemData.price * num
    var item_worth = ItemWorth.OTHER
    if (sceneName === ModuleName.BUY_GAME_COINS) {
        // priceAll = goodsMeta.getCoin() || 0
        item_worth = ItemWorth.GAME_COINS
        sceneName = ModuleName.SHOP
    } else if (sceneName === ModuleName.BUY_HAPPY_COINS) {
        // priceAll = goodsMeta.getCash() || 0
        item_worth = ItemWorth.HAPPY_COINS
        sceneName = ModuleName.SHOP
    } else if (sceneName === ModuleName.BUY_RMB_COINS) {
        // priceAll = goodsMeta.getThirdRmb()
        // if (priceAll === 0) {
            // priceAll = goodsMeta.getRmb() || 0
        // }
        item_worth = ItemWorth.RMB
        sceneName = ModuleName.SHOP
    } else if (dcData && dcData.item_worth) {
        item_worth = dcData.item_worth;
    }
    // function getItemPrice(itemId) {
    //     var propMeta = MetaManager.getInstance().getPropMeta(itemId)
    //     return propMeta && propMeta.price || 0
    // }
    // for (var i = 1, v = itemsList[1]; v; i++, v = itemsList[i]) {
    //     priceTotal = priceTotal + getItemPrice(v.itemId) * v.num * num
    // }
    let targetId
    let param
    for (var i = 1, v = itemsList[1]; v; i++, v = itemsList[i]) {
        var coin1 = 0
        if (tonumber(v.propId) === ItemType.COIN) {
            coin1 = UserManager.getInstance().getUserRef().getCoin() || 0
        } else if (tonumber(v.propId) === ItemType.GOLD) {
            coin1 = UserManager.getInstance().getUserRef().getCash() || 0
        } else {
            coin1 = 0
        }
        let item1 = getPropNumber(v.propId);
        UserProp.getInstance().addProp(v.propId, v.num * num, targetId || itemId, param, sceneName)
        dcData = dcData || table()
        dcData.item_worth = item_worth
        dcData.worth_num = 0
        if (priceTotal && priceTotal > 0) {
            if (dcData.item_worth == ItemWorth.OTHER) { } else {
                // worth_num需求打单位：元
                let scale = dcData.item_worth == ItemWorth.RMB? 0.1: 1; // 人民币支付需要从角转换为元
                dcData.worth_num = (v.price * num * scale)
            }
        }
        dcData.goods_id = itemId
        dcData.item1 = item1;
        dcData.item2 = getPropNumber(v.propId);
        // DCAssist.dc4GetThings(v.itemId, v.num * num, sceneName, dcData)
        //  为区别道具购买来源，因此需要从外部通过dcData.source参数传入来源信息，如果不存在来源信息，则使用默认的Shop
        if (dcData.source) {
            DCAssist.dc4GetThings(v.propId, v.num * num, dcData.source, dcData)
        } else {
            DCAssist.dc4GetThings(v.propId, v.num * num, sceneName, dcData)
        }
        var coin2 = 0
        if (tonumber(v.propId) === ItemType.COIN) {
            coin2 = UserManager.getInstance().getUserRef().getCoin() || 0
        } else if (tonumber(v.propId) === ItemType.GOLD) {
            coin2 = UserManager.getInstance().getUserRef().getCash() || 0
        } else {
            coin2 = 0
        }
        dcData = dcData || table()
        dcData.coin1 = coin1 || 0
        dcData.coin2 = coin2 || 0
        //  为区别货币获得来源，因此需要从外部通过dcData.source参数传入来源信息，如果不存在来源信息，则使用默认的Shop
        if (dcData.source) {
            DCAssist.dc4GetCurrency(v.itemId, v.num * num, dcData.source, dcData)
        } else {
            DCAssist.dc4GetCurrency(v.itemId, v.num * num, sceneName, dcData)
        }
    }
}

function getPropNumber(propId) {
    if (UserPropData.isTimeProp(propId)) {
        return UserManager.getInstance().getUserTimePropNumber(propId);
    } else {
        return UserManager.getInstance().getUserPropNumber(propId);
    }
}

function getItemPrice(itemId) {
    var propMeta = MetaManager.getInstance().getPropMeta(itemId)
    if (!propMeta)
        return 0;
    return propMeta.displayPrice || propMeta && propMeta.price || 0;
}